import type Vue from 'vue'
import { getCurrentInstance as getCurrentInstanceOriginal } from 'vue'
import invariant from 'invariant'

// eslint-disable-next-line @typescript-eslint/ban-types
type VueComponentListener = Function

export function executeListener(
  argument: VueComponentListener | VueComponentListener[],
  ...args: unknown[]
): void {
  if (typeof argument === 'function') {
    argument(...args)
  } else {
    argument.forEach((fn) => fn(...args))
  }
}

export function getCurrentInstance(): { proxy: Vue } {
  const instance = getCurrentInstanceOriginal()
  invariant(instance !== null, '')
  return instance
}

/** Immutable version of `Array#slice` */
export function immutableSlice<T>(
  array: T[],
  index: number,
  itemToReplace: T
): T[] {
  return [...array.slice(0, index), itemToReplace, ...array.slice(index + 1)]
}

export function extractIdFromElement(element: HTMLElement): number {
  const { id: raw } = element.dataset
  if (raw === undefined) {
    throw new Error(`Unable to extract id from element ${element}`)
  }
  const id = parseInt(raw)
  if (Number.isNaN(id)) {
    throw new Error(`Unable to extract id from element ${element}`)
  }
  return id
}

export { default as booleanToWord } from './booleanToWord'
export { default as calculatePosition } from './calculatePosition'
export { default as calculateNewPosition } from './calculateNewPosition'
export { default as changed } from './changed'
export { default as changePosition } from './changePosition'
export { default as dialogify } from './dialogify'
export { default as downloadJson } from './downloadJson'
export { default as generateId } from './generateId'
export { default as uuid } from './generateId'
export { default as groupBy } from './groupBy'
export { default as hasSlot } from './hasSlot'
export { default as indexBy } from './indexBy'
export { default as isDefined } from './isDefined'
export { default as mountVueToBody } from './mountVueToBody'
export { default as normalizeSlot } from './normalizeSlot'
export { default as setDifference } from './setDifference'
export { default as sortByPosition } from './sortByPosition'
export { default as withRelation } from './withRelation'
export { default as isHtml } from './isHtml'
